import React, { useState, useEffect } from 'react';
import { useSxStyles } from "../styles/sxStyles";
import { getDecimal } from "../config/utils";
import Grid2 from '@mui/material/Grid2';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from "@mui/material/Typography";
import ListItemText from '@mui/material/ListItemText';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';

const OptionList = (props) => {
    const options = props.options;
    const balance = props.balance;
    const classes = useSxStyles;
    const [option, setOption] = useState(null);

    useEffect(() => {
        balance.trafficSchoolId = option;
        if (option) {
            const opts = options.filter(o => o.optionId === option);
            if (opts && opts.length > 0) {
                balance.trafficSchoolType = opts[0].optionType;
            } else {
                balance.trafficSchoolType = null;
            }
        } else {
            balance.trafficSchoolType = null;
        }
    }, [option])

    return (<>
        <List sx={{...classes.list, maxHeight: '100%', marginLeft: '1rem'}} >
            <ListItem alignItems='flex-start' sx={classes.listPadding}>
                <ListItemText
                    sx={classes.listText}
                    primary={
                        <Grid2
                            container
                            spacing={1}
                            alignItems="top"
                        >
                            <Grid2 size={12}><Typography variant='subtitle2' sx={{color: 'sienna', fontSize: '1.2rem'}}>Traffic School Option(s)</Typography></Grid2>
                            <Grid2 size={3}>Select</Grid2>
                            <Grid2 size={6}>Description</Grid2>
                            <Grid2 style={{paddingLeft: '1rem'}} size={3}>Amount</Grid2>
                        </Grid2>
                    }
                    slotProps={{
                        primary: {
                            component: 'span',
                            color: 'textPrimary',
                            sx: {fontSize: '.9rem', lineHeight: '.7rem'},
                        }
                    }}
                />
            </ListItem>
            <RadioGroup name='trafficSchool' onChange={(e) => {setOption(e.target.value)}} value={option}>
                <>
                    { options && options.length > 0 && options.map((opt) => {
                        return (
                            (<ListItem alignItems='flex-start' disableGutters sx={{paddingTop: '0', paddingBottom: '0'}}>
                                <ListItemText
                                    sx={classes.listText}
                                    primary={
                                        <Grid2
                                            container
                                            spacing={1}
                                            alignItems="top"
                                        >
                                            <Grid2 size={3}>
                                                <FormControlLabel
                                                    value={opt.optionId}
                                                    control={
                                                        <Radio
                                                            size='small'
                                                            sx={{marginLeft: '1rem', paddingBottom: '0', paddingLeft: '.5rem', paddingTop: '0', position: ''}}
                                                        />
                                                    }
                                                    label=''
                                                    sx={{paddingLeft: '0', paddingTop: '0'}}
                                                />
                                            </Grid2>
                                            <Grid2 size={6}>{opt.optionDescription ? opt.optionDescription : opt.optionTypeDescription}</Grid2>
                                            <Grid2
                                                sx={{textAlign: 'right', paddingRight: {xs: '0', sm: '10%', lg: '15%'}}}
                                                size={3}>{getDecimal(opt.optionAmount)}</Grid2>
                                        </Grid2>
                                    }
                                    slotProps={{
                                        primary: {
                                            component: 'span',
                                            color: 'textPrimary',
                                            sx: {fontSize: '.9rem', paddingLeft: '.2rem'}
                                        }
                                    }}
                                />
                            </ListItem>)
                        );
                    })}
                    { option &&
                        <ListItem alignItems='flex-start' disableGutters sx={{paddingTop: '0', paddingBottom: '0'}}>
                            <ListItemText
                                sx={classes.listText}
                                primary={
                                    <Grid2
                                        container
                                        spacing={1}
                                        alignItems="top"
                                    >
                                        <Grid2 size={3}>
                                            <FormControlLabel
                                                value={null}
                                                control={
                                                    <Radio
                                                        size='small'
                                                        sx={{marginLeft: '1rem', paddingBottom: '0', paddingLeft: '.5rem', paddingTop: '0', position: ''}}
                                                    />
                                                }
                                                label=''
                                                sx={{paddingLeft: '0', paddingTop: '0'}}
                                            />
                                        </Grid2>
                                        <Grid2 size={9}>Remove traffic school selection</Grid2>
                                    </Grid2>
                                }
                                slotProps={{
                                    primary: {
                                        component: 'span',
                                        color: 'textPrimary',
                                        sx: {fontSize: '.9rem', paddingLeft: '.2rem'}
                                    }
                                }}
                            />
                        </ListItem>
                    }
                </>
            </RadioGroup >
        </List>
    </>);
}

export default OptionList;
